<template>
  <div style="height:100%;user-select: none;cursor: pointer;">
    <div style="display: flex;">
      <div style='flex:1;line-height: 46px;color: gray;font-size: 12px;text-align: right;'>提示：可使用鼠标在复选框的列内滑动选中或取消指定行</div>
      <vxe-toolbar ref="autoToolbar" custom style="background: transparent;"></vxe-toolbar>
    </div>
    <div style="height:calc(100% - 46px);">
      <vxe-grid ref="autoTable" v-contextmenu:contextmenu max-height="100%" :columns='crrColumns' :data='data' border show-overflow highlight-current-row highlight-hover-row highlight-current-column highlight-hover-column resizable auto-resize :id='id' column-key :custom-config={storage:{visible:true,resizable:true}} :radio-config={highlight:true} :checkbox-config={highlight:true,range:true} :header-cell-class-name="headerCellClassName" :cell-style="cellStyle" :cell-class-name="cellClass" v-bind="$attrs" v-on="$listeners" @cell-click='cellClick'>
        <template v-for="($scopedSlot,name) in $scopedSlots" v-slot:[name]='{row}'>
          <slot :name="name" :row='row'></slot>
        </template>
      </vxe-grid>
    </div>
    <v-contextmenu theme='dark' ref="contextmenu">
      <v-contextmenu-item @click="copyblok">复制</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>

<script>
// 修改了单独组件的单元格样式和复制通知
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable, { size: 'mini' })
import './tableRenderer.js'
import Sortable from 'sortablejs'
import Contextmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
Vue.use(Contextmenu)
import Clipboard from 'vue-clipboard2'
Vue.use(Clipboard)
export default {
  props: {
    id: {
      type: String,
      default: 'autoTable',
      desc: '标识'
    },
    columns: {
      type: Array,
      required: true,
      desc: '列配置'
    },
    columnsHand: {
      type: Function,
      default: () => ({}),
      desc: '列复制函数'
    },
    data: {
      type: Array,
      required: true,
      desc: '数据'
    }
  },
  data() {
    return {
      sortSave: [], // 排序
      keyBoard: [], // 键盘
      isActivated: true, // 激活
      startCell: [], // 范围左上
      endCell: [] // 范围右下
    }
  },
  computed: {
    // 排序配置
    columnsSort() {
      let columnsSort = [...this.columns]
      return columnsSort.sort((crr, prev) => {
        if (crr.field && prev.field) {
          let crr_index = this.sortSave.indexOf(crr.field)
          let prev_index = this.sortSave.indexOf(prev.field)
          if (crr_index != -1 && prev_index != -1 && crr_index < prev_index) return -1
        }
        return 1
      })
    },
    // 显示配置
    crrColumns() {
      let crrColumns = [...this.columnsSort]
      crrColumns.forEach((element) => {
        element.cellRender = { name: '$Text', events: { onmousedown: this.onmousedown, onmouseover: this.onmouseover } }
        if (element.formatter) element.cellRender.formatter = element.formatter
        // 自定义元素重复绘制，猜测这里值会继承（测试成功），不可直接删除，避免下次重回配置丢失
        if (element.slots) {
          element.oldslots = element.slots
          delete element['slots']
        }
        if (element.oldslots && element.oldslots.default) {
          element.cellRender.slotsDefault = this.$scopedSlots[element.oldslots.default]
        }
      })
      return [{ type: 'seq', width: 50, fixed: 'left' }, { type: 'checkbox', width: 50, fixed: 'left' }, ...crrColumns]
    },
    // 不可选取列
    fixedColumns() {
      return this.crrColumns.filter((item) => item.type).map((_, i) => i)
    }
  },
  mounted() {
    this.$refs.autoTable.connect(this.$refs.autoToolbar) // 关联表格和工具栏
    this.getSort() // 初始化列排序
    this.columnDrop() // 绑定列置换
    this.onKeyboard() // 绑定按键
  },
  activated() {
    this.isActivated = true // 激活
  },
  deactivated() {
    this.isActivated = false // 非激活
  },
  methods: {
    // 读取排序
    getSort() {
      let COLUMN_SORT = localStorage.getItem('COLUMN_SORT') || '{}'
      let crr_sort_obj = JSON.parse(COLUMN_SORT)[this.id] || []
      this.sortSave = crr_sort_obj
    },
    // 设置排序
    setSort(crr_sort_obj) {
      this.sortSave = crr_sort_obj
      let COLUMN_SORT = localStorage.getItem('COLUMN_SORT') || '{}'
      let sort_obj = JSON.parse(COLUMN_SORT)
      sort_obj[this.id] = this.sortSave
      localStorage.setItem('COLUMN_SORT', JSON.stringify(sort_obj))
    },
    // 列头类名
    headerCellClassName({ columnIndex }) {
      if (this.fixedColumns.indexOf(columnIndex) == -1) {
        return 'drop'
      }
    },
    // 初始化列置换(这里使用property属性，既是field配置，所以field为必传)
    columnDrop() {
      const $table = this.$refs.autoTable
      this.sortable2 = Sortable.create($table.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
        handle: '.vxe-header--column.drop',
        animation: 150,
        onEnd: ({ newIndex, oldIndex }) => {
          const { fullColumn, tableColumn } = $table.getTableColumn()
          // dom操作
          const oldColumnIndex = $table.getColumnIndex(tableColumn[oldIndex])
          const newColumnIndex = $table.getColumnIndex(tableColumn[newIndex])
          const currRow = fullColumn.splice(oldColumnIndex, 1)[0]
          fullColumn.splice(newColumnIndex, 0, currRow)
          // $table.loadColumn(fullColumn) // 用下面本地记录
          // 保存操作
          let crr_sort_obj = fullColumn
            .filter((item) => item.property)
            .reduce((arr, crr) => {
              arr.push(crr.property)
              return arr
            }, [])
          this.setSort(crr_sort_obj)
          this.getSort()
        }
      })
    },
    // 范围开始选择
    onmousedown({ rowIndex, columnIndex }, { button }) {
      if (button != 0 && this.fixedColumns.indexOf(columnIndex) == -1) return //0为鼠标左键
      this.keyBoard['select'] = true
      this.startCell = this.endCell = [rowIndex, columnIndex]
      this.$refs.autoTable.clearCurrentRow()
    },
    // 范围滑动中
    onmouseover({ rowIndex, columnIndex }) {
      if (this.keyBoard['select'] && this.fixedColumns.indexOf(columnIndex) == -1) {
        this.endCell = [rowIndex, columnIndex]
      }
    },
    // 范围结束选择
    onmouseup() {
      this.keyBoard['select'] = false
    },
    // 单元格动态样式
    cellStyle({ rowIndex, columnIndex }) {
      if (this.judgments(rowIndex, columnIndex)) {
        return {
          backgroundColor: 'teal',
          color: '#ffffff'
        }
      }
    },
    // 单元格动态类名
    cellClass({ rowIndex, columnIndex }) {
      if (this.judgments(rowIndex, columnIndex)) {
        return 'teal'
      }
    },
    // 初始化按键
    onKeyboard() {
      document.addEventListener('keydown', (e) => {
        this.keyBoard[e.key] = true
        if (this.isActivated && this.keyBoard['Control'] && this.keyBoard['c']) {
          this.copyblok() //复制操作
        }
      })
      document.addEventListener('keyup', (e) => {
        this.keyBoard[e.key] = false
      })
      // 鼠标松开事件
      document.onmouseup = () => this.onmouseup() // 范围选择可能在表格之外放开
    },
    // 复制选中区域单元格
    copyblok() {
      let copyText = ''
      this.data.map((row, rowIndex) => {
        let rowtext = ''
        this.crrColumns.map((column, columnIndex) => {
          if (this.judgments(rowIndex, columnIndex)) {
            if (rowtext) rowtext += '\t'
            rowtext += this.gettext(row, column)
          }
        })
        if (!rowtext) return
        if (copyText) copyText += '\n'
        copyText += rowtext
      })
      if (!copyText) return
      this.$copyText(copyText)
    },
    // 单击单元格
    cellClick({ row, rowIndex, columnIndex }) {
      // let selectRecords = this.$refs.autoTable.getCheckboxRecords()
      if (this.judgment(rowIndex, columnIndex)) {
        this.$refs.autoTable.clearCheckboxRow()
        this.$refs.autoTable.setCheckboxRow([row], true)
      }
    },
    // ---------------------util---------------------
    // 存在slots.default插槽的列必须明确指定复制回调的内容(因为列复制容许为空数据，为空时不可直接使用field对应的数据)
    gettext(row, column) {
      if (column.oldslots && column.oldslots.default) return this.columnsHand(row, column.oldslots.default) // 无返回值会出现undefined
      if (column.formatter) return column.formatter(row) // 无返回值会出现undefined
      return row[column.field] // 无返回值会出现undefined
    },
    // 单元格判断
    judgment(rowIndex, columnIndex) {
      if (this.startCell.length) {
        if (this.startCell[0] == rowIndex && this.startCell[1] == columnIndex) {
          return true
        }
      }
    },
    // 范围单元格判断
    judgments(rowIndex, columnIndex) {
      if (this.startCell.length && this.endCell.length) {
        if ((this.startCell[0] <= rowIndex && rowIndex <= this.endCell[0]) || (this.endCell[0] <= rowIndex && rowIndex <= this.startCell[0])) {
          if ((this.startCell[1] <= columnIndex && columnIndex <= this.endCell[1]) || (this.endCell[1] <= columnIndex && columnIndex <= this.startCell[1])) {
            return true
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.vxe-toolbar {
  background: transparent;
}
.celltext {
  position: relative;
  width: calc(100% + 20px);
  left: -10px;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 36px;
  height: 36px;
}
.vxe-header--row .vxe-header--column.sortable-ghost,
.vxe-header--row .vxe-header--column.sortable-chosen {
  background-color: #dfecfb;
}
.vxe-body--column.teal .celltext * {
  background-color: teal !important;
  color: white !important;
}
.vxe-body--column .blue {
  color: blue;
  cursor: pointer;
}
.vxe-body--column .red {
  color: red;
}
.vxe-body--column .gray {
  color: gray;
}
</style>
